import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IEditEventPayload extends ISagaCb {
    eventId: string
    data: any
    sagaCB?: {
        onSuccess: any
        onFailure?: any
        successMessage?: string
    }
}

export interface IEditEventState {
    status: string
    data: any
    errors: any
}

const initialState: IEditEventState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editEvent = createSlice({
    name: 'event/edit',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditEventPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editEventActions = editEvent.actions
export default editEvent.reducer
